import styled from 'styled-components';
import { ProductiveHeading07, SingleLineEllipsis } from 'components/styles';

const TableComponent = styled.table`
  width: 100%;
  table-layout: fixed;
`;

const TableHeaderRow = styled.tr`
  background: var(--coolest-gray-20);
`;
const TableHeaderCell = styled.th`
  padding: var(--spacing-03);
  ${ProductiveHeading07};
  ${SingleLineEllipsis};
`;
const TableBodyRow = styled.tr``;
const TableBodyCell = styled.td`
  padding: var(--spacing-03);
`;

type Header = typeof TableHeaderRow & {
  Cell: typeof TableHeaderCell;
};

const Header: Header = TableHeaderRow as Header;

Header.Cell = TableHeaderCell;

type Body = typeof TableBodyRow & {
  Cell: typeof TableBodyCell;
};

const Body: Body = TableBodyRow as Body;

Body.Cell = TableBodyCell;

type WidgetTable = typeof TableComponent & {
  HeaderRow: typeof Header;
  BodyRow: typeof Body;
};

const WidgetTable: WidgetTable = TableComponent as WidgetTable;

WidgetTable.BodyRow = Body;
WidgetTable.HeaderRow = Header;

export { WidgetTable };
